const form = {
  formId: "edit-user-form",
  formField: {
    firstName: {
      name: "first_name",
      label: "first name",
      type: "text",
      placeholder: "eg. Micheal",
      errorMsg: "First name is required.",
    },
    lastName: {
      name: "last_name",
      label: "last name",
      type: "text",
      placeholder: "eg. Prior",
      errorMsg: "Last name is required.",
    },
    organization: {
      name: "organization",
      label: "organization",
      type: "text",
      placeholder: "eg. CXFabric",
    },
    yourLocation: {
      name: "your_location",
      label: "location",
      type: "text",
      placeholder: "eg. 123 Street, New York, NY",
      errorMsg: "Location is required",
    },
    roleId: {
      name: "role_id",
      label: "role",
      type: "select",
      placeholder: "Role",
      errorMsg: "Role is required",
    },
    email: {
      name: "email_address",
      label: "email address",
      type: "email",
      placeholder: "eg. soft@dashboard.com",
      errorMsg: "Email address is required.",
      invalidMsg: "Your email address is invalid",
    },
    mobile: {
      name: "mobile",
      label: "mobile",
      type: "tel",
      inputMode: "numeric",
      pattern: "[0-9]*",
      placeholder: "eg. 0911 111 1111 - must be 11 digits",
      errorMsg: "mobile is required.",
      minimumMsg: "Your mobile must be 10 or 11 digits",
      invalidMsg: "Your mobile is invalid - 11 digits only",
    },
    phone: {
      name: "phone",
      label: "phone",
      type: "text",
      placeholder: "eg.123-45-678 - must be 8 digits",
      errorMsg: "Phone is required.",
      minimumMsg: "Your mobile must be 7 or 8 digits",
      invalidMsg: "Your phone is invalid - 8 digits only",
    },
    language: {
      name: "language",
      label: "language",
      type: "select",
      placeholder: "Language",
    },
  },
};

export default form;
